module.exports = function() {
  return new Worker(__webpack_public_path__ + "6ff48954115af4b50a65.worker.js");
};